import { Quote } from 'components/Quote'
import { ReactNode } from 'react'

export const content_lifestyle: {
  title: string
  author: string
  autorBio: string
  content: ReactNode
  link: number
}[] = [
  {
    title: 'Wann wird veganes Fondue geniessbar?',
    author: 'Daniel Böniger',
    autorBio: '82942646/daniel-boniger',
    content: (
      <>
        <p>
          Es gibt Dinge, die es eigentlich so nicht geben dürfte. Dazu gehört
          Fussballgucken ohne Bier wie jüngst in Katar. In dieselbe Kategorie
          gehört Fondue ohne geschmolzenen Käse! Auch wenn die angesagte Zürcher
          Küchenchefin Zizi Hattab in ihrem neuen Kochbuch ein ebensolches
          Gericht auf der Basis von eingeweichten und mit Wasser im Standmixer
          pürierten Cashewkernen rezeptiert hat.
        </p>
        <p>
          Es dürfte einen Grund geben, warum sie die dickflüssige Masse am Ende
          über sehr aromatische Bergkartoffeln gibt und das Ganze mit ordentlich
          viel Szechuan-Chiliöl würzt …
        </p>
        <Quote>
          Das Geschäftsmodell mit veganen Ersatzprodukten hat den ersten
          Höhepunkt bereits hinter sich.
        </Quote>
        <p>
          Nein, es ist wirklich nicht davon auszugehen, dass veganes Fondue eine
          kulinarische Zukunft hat. Dies nicht zuletzt, weil sich die
          Nahrungsmittelindustrie kaum anschicken wird, diese Spezialität zu
          perfektionieren. Das Geschäftsmodell mit veganen Ersatzprodukten hat
          nämlich den ersten Höhepunkt bereits hinter sich. Das zeigen die
          Umsatzeinbussen bei «Beyond Meat», dem pflanzenbasierten
          «Fake-Fleisch».
        </p>
        <p>
          Da dürften internationale Konzerne keinen Grund sehen, warum sie sich
          für ein Schweizer Nischenprodukt wie Fondue interessieren sollten.
          Erst recht nicht, zumal sich der Absatz auf die kalte Jahreshälfte
          beschränkt.
        </p>
      </>
    ),
    link: 309487261540,
  },
  {
    title: 'Wohin in die Ferien?',
    author: 'Claudia Schmid',
    autorBio: '43913206/claudia-schmid',
    content: (
      <>
        <p>
          Mit dem Urlaub ist es tatsächlich nicht mehr so einfach, denn vieles
          geht ja nicht oder nicht mehr: Flugreisen (schlecht fürs Klima),
          europäische Hotspots wie Venedig, Rom, Florenz (Massentourismus),
          Kreuzfahrten (energietechnisch des Teufels), überwintern in einem
          warmen Emirat (schwierig, weil eine Autokratie).
        </p>
        <p>
          «Bleiben Sie zu Hause» ist auch kein Tipp mehr, denn während der
          Pandemie haben Sie die Schweiz ja von hinten bis nach vorne
          angeschaut, sodass Sie mittlerweile die Einwohnerzahlen von Bergün und
          La Chaux-de-Fonds auswendig kennen. Trotzdem wollen Sie wieder mal was
          anderes sehen als den Rheinfall.
        </p>
        <Quote>
          Was immer Sie vorhaben – überlegen Sie sich, ein Interrail-Ticket zu
          kaufen.
        </Quote>
        <p>
          Richten Sie den Blick auf unbekannte Regionen der Nachbarländer und
          ihrer Nachbarländer! Sie sind alle mit dem Zug oder Auto erreichbar.
          Das bergige Trentino in Italien ist so eine Gegend, das grüne Umbrien
          im Zentrum oder das Friaul im Nordosten. Dort gibt es Weine mit
          wohlklingenden Namen wie Ramandolo und gesellige Städte wie Udine. Von
          Udine können Sie direkt weiter ins Nachbarland Slowenien fahren, ein
          abwechslungsreiches Land mit Badeseen, Burgen, einer Meeresküste und
          einer bergigen Region.
        </p>
        <p>
          Auch in Frankreich lohnt es sich, unbekannte Départements zu beachten
          – es sei denn, Sie haben Lust, Ihre Sommerferien im Stau zwischen
          Saint-Maxime und Saint-Tropez zu verbringen. Haben Sie mal von der
          Ariège gehört? Eine verwunschene Gegend mit Pferden, Badeflüssen und
          alten Schlössern an der Grenze zu Spanien und Andorra. Grenznahe
          Destinationen – San Sebastián, Perpignan, Girona, you name it – sind
          sowieso interessant, weil Einflüsse mehrerer Länder die Orte prägen.
        </p>
        <p>
          Was immer Sie vorhaben – überlegen Sie sich, ein Interrail-Ticket zu
          kaufen. Damit kommen Sie günstig mit dem Zug durch Europa.
        </p>
      </>
    ),
    link: 805541635500,
  },
  {
    title: 'Sollen Männer ihre Fingernägel lackieren?',
    author: 'Lisa Füllemann',
    autorBio: '79545900/lisa-fullemann',
    content: (
      <>
        <p>
          Klar. Wer dieses Jahr bei Fotos von Stars wie Harry Styles, Machine
          Gun Kelly oder Bad Bunny genau hinschaute, dem fiel auf: Ihre Nägel
          sind stets bunt lackiert. Und egal ob glitzernd, knallpink oder
          regenbogenfarben – mit ihrer Maniküre sehen sie nicht minder
          «männlich» aus. Erstere zwei haben sogar ihre eigene
          geschlechtsneutrale Beauty-Linie lanciert und hinterfragen auch sonst
          gerne mit Federboas, Kleidern aus Spitze und Absatzschuhen das
          traditionelle Männerbild.
        </p>
        <p>
          Denn vor allem die Generation Z, also die unter 25-Jährigen, zweifelt
          daran, wie weit die klassischen Geschlechtsnormen für sie noch Sinn
          ergeben. Dadurch lösen sich die Grenzen auch in der Mode und in der
          Kosmetik zunehmend auf. Selbst in der Schweiz sieht man im Tram oder
          beim Einkaufen immer häufiger den modernen Typ Mann, der seine Nägel
          mit Smiley-Gesichtern verziert hat, seinen Bauch unter ultrakurz
          geschnittenen, eng anliegenden Crop-Tops hervorblitzen lässt oder
          seinen Hals mit einer Perlenhalskette schmückt. Vielleicht weil es
          ihnen einfach gefällt. Vielleicht aber auch, weil sie sich
          demonstrativ von toxischer Männlichkeit abgrenzen wollen.
        </p>
        <Quote>
          Höchste Zeit, sich von einengenden Geschlechternormen zu
          verabschieden.
        </Quote>
        <p>
          Dass sich genderneutrale Mode aber keineswegs nur in der
          übersensibilisierten Gen-Z-Sphäre abspielt, wurde spätestens dann
          klar, als der 58-jährige Brad Pitt im August in einem Leinen-Rock über
          den roten Teppich ging. Pitts Begründung für seinen Look? «Wir werden
          eh alle irgendwann sterben, also lasst uns das Leben ein wenig
          aufmischen.»
        </p>
        <p>
          Recht hat er! Mode und Schönheitsprodukte sollten in erster Linie
          Spass machen. Höchste Zeit also, sich von einengenden
          Geschlechternormen zu verabschieden.
        </p>
      </>
    ),
    link: 210234798234,
  },
  {
    title: 'Muss ich meine Wohnung schöner einrichten?',
    author: 'Pascal Blum',
    autorBio: '92243852/pascal-blum',
    content: (
      <>
        <p>
          Die spontane Antwort, wenn man mal wieder irgendwo eingeladen ist:
          Wahrscheinlich schon. Die längere Antwort lautet, dass die Leute nach
          dem Designboom in der Pandemie eher zurückhaltend geworden sind.
          Innenarchitektin Ingrid Gogesch arbeitet in einem Möbelgeschäft in
          Zürich und sagt, das Geschäft laufe dieses Jahr weniger gut: «Haben
          wir in der Pandemie profitiert, weil die Menschen nicht reisen konnten
          und gesehen haben, was zu Hause fehlt, dann ist es heuer so, dass wir
          den Kürzeren ziehen wegen eines Weltzustands, der von Krieg und
          Ängsten bestimmt ist.»
        </p>
        <p>
          Also leben die Leute noch eine Weile mit dem alten Sofa, das Teil tut
          es ja noch. Gogesch sieht ein stärkeres Bewusstsein für Nachhaltigkeit
          und sichere Investition. Aber die nötige Liquidität für so einen Bell
          Coffee Table von Sebastian Herkner muss man ja auch noch haben. Und da
          fänden viele junge Kundinnen und Kunden Designermöbel schlicht
          schweineteuer. Fürs Einrichten brauche es eben auch eine gewisse
          geistige Bildung und Reife: «Man muss selber schon ein ‹Klassiker›
          sein, sprich mindestens 40 Jahre alt.😊»
        </p>
        <Quote>
          Wer alles so lässt, wie es ist, wird irgendwann blind für die
          Unstimmigkeiten.
        </Quote>
        <p>
          Und fertig eingerichtet ist man sowieso nie: Mit den Lebensphasen
          ändert sich die Einrichtung, man zieht um, der Ehemann oder die
          Freundin zieht aus, später: Downsizing. Davon abgesehen scheint sich
          allgemein der Blick auf die eigenen vier Wände geschärft zu haben. Das
          weiss jeder Interior-Stylist: Wer alles so lässt, wie es ist, wird
          irgendwann blind für die Unstimmigkeiten.
        </p>
        <p>
          Richten Sie also Ihre Wohnung unbedingt schöner ein. Und tun Sie es im
          Wissen, dass Sie nie zu einem Ende kommen.
        </p>
      </>
    ),
    link: 494999080103,
  },
  {
    title: 'Darf ich 2023 noch einen Aperol Spritz bestellen?',
    author: 'Daniel Böniger',
    autorBio: '82942646/daniel-boniger',
    content: (
      <>
        <p>
          Selbstverständlich dürfen Sie das tun. Allerdings müssen Sie dann in
          Kauf nehmen, dass Ihnen die Gastgeber billigsten Prosecco ins Glas
          geben, gemixt mit unglaublich vielen halb geschmolzenen Eiswürfeln,
          einem Stück nicht sauber gereinigter Zitrusfrucht und ausserdem einem
          Likör, bei dem es sich im Wesentlichen um oranges Zuckerwasser
          handelt. Ich sage nur: Lebensmittelfarbstoff E110! Na, wenn das kein
          Kopfweh gibt.
        </p>
        <Quote>
          Schenkt man den Trendforschern Glauben, dann trinkt 2023, wer hip
          sein möchte, einen mit Chili scharf gemachten Cocktail.
        </Quote>
        <p>
          Kommt bei dieser Bestellung erschwerend hinzu, dass Sie sich auf der
          Gartenterrasse mit einem Aperol Spritz als Ewiggestrige oder
          Ewiggestriger outen. Weil es, erstens, dieses Getränk in Italien seit
          über 100 Jahren in dieser Form gibt. Und weil, zweitens, das planlose
          Sich-vollaufen-Lassen – und wofür soll Aperol Spritz sonst gut sein? –
          längst nicht mehr dem Zeitgeist entspricht.
        </p>
        <p>
          Schenkt man den Trendforschern Glauben, dann trinkt 2023, wer wirklich
          hip sein möchte, einen mit Chili scharf gemachten Cocktail, dem
          lokale, nachhaltige und sehr exklusive Spirituosen zugrunde liegen.
          Und zwar bloss einen Drink statt mehrere – den aber vielleicht sogar
          im Restaurant oder zu Hause statt in der Bar. 
        </p>
      </>
    ),
    link: 502421893983 ,
  },
]
